export default __webpack_public_path__ + "static/media/weiterentwicklung.4af0345d.svg";